var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1To2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "282px",
    height: "64px",
    viewBox: "0 0 282 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp-|-Signup-FInal--(Desktop)",
    transform: "translate(-137.000000, -310.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.334553,329.163879 C198.020589,461.163879 311.050171,241.295448 421.644531,335.11454",
    id: "Path-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1To2);
export default __webpack_public_path__ + "static/media/step-1-to-2.9466a2bb467114986ecad66119861b20.svg";
export { ForwardRef as ReactComponent };